// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === "7888") return "css/design_system-69fef30671ca4670.css";
if (chunkId === "2128") return "css/2128-c4fb6e03132e1a07.css";
if (chunkId === "4662") return "css/4662-44eccc0403d5f3f3.css";
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {"1204": "b31906f33c887815","2044": "f73399613c4344dc","2429": "a73d2fa285645c40","4170": "d7df7df552b688b7","7212": "f94219ab15d7e90a","7364": "a8d311b114ec77ce","8138": "b31906f33c887815",}[chunkId] + ".css"
}